import { FC } from 'react';
import styles from './Navigation.module.scss';
import { AccountButton } from '../AccountButton';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import { selectSite } from 'src/features/site-slice';
import { EVENTS_ROOT } from 'src/redesign/shared/routes';
import {
  hasRequestEventCreationRoleSelector,
  isAdminOrOwnerSelector,
  isEventManagerSelector,
  isEventHostManagerSelector,
} from 'src/redesign/features/Account/store/selectors';

export const Navigation: FC = () => {
  const hasRequestEventCreationRole = useAppSelector(hasRequestEventCreationRoleSelector);
  const isAdminOrOwner = useAppSelector(isAdminOrOwnerSelector);
  const isEventManager = useAppSelector(isEventManagerSelector);
  const isEventHostManager = useAppSelector(isEventHostManagerSelector);
  const site = useAppSelector(selectSite);

  // Determine if billing link should be visible
  const shouldShowBilling =
    (!hasRequestEventCreationRole && !isEventManager && !isEventHostManager) || isAdminOrOwner;

  // Show payouts if site is a marketplace
  const shouldShowPayouts = site?.is_marketplace;

  return (
    <nav className={styles.navigation}>
      <a
        href="https://ticketspotapp.com/docs"
        className={`${styles.navigationLink} ${styles.hideOnMobile}`}
      >
        Help
      </a>
      {!isEventHostManager && (
        <a
          href="https://calendly.com/chris-ticketspotapp/support-call"
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.navigationLink} ${styles.hideOnMobile}`}
        >
          Book a free setup call
        </a>
      )}
      {shouldShowBilling && (
        <Link
          to={`${EVENTS_ROOT}/billing`}
          className={`${styles.navigationLink} ${styles.hideOnMobile}`}
        >
          Billing
        </Link>
      )}
      {shouldShowPayouts && (
        <Link
          to={`${EVENTS_ROOT}/payouts`}
          className={`${styles.navigationLink} ${styles.hideOnMobile}`}
        >
          Payouts
        </Link>
      )}
      <AccountButton />
    </nav>
  );
};
